
























import { Component, Vue } from 'vue-property-decorator';
import { Prop } from 'vue-property-decorator';
import Axios, { AxiosResponse } from 'axios';
import { MarkerResult } from './interfaces/markers';
import { EventResult, Event } from './interfaces/events';
import Map from './components/Map.vue';
import EventList from './components/EventList.vue';
import Pager from './components/Pager.vue';
import Search from './components/Search.vue';

@Component({
  components: {
    Map,
    EventList,
    Pager,
    Search,
  },
})
export default class App extends Vue {
  @Prop({ default: '' })
  readonly markersUrl!: string;

  @Prop({ default: '' })
  readonly listUrl!: string;

  @Prop({ default: '' })
  readonly searchUrl!: string;

  @Prop({ default: '' })
  readonly apiKey!: string;

  @Prop({ default: [] })
  readonly categories!: {uid: number, name: string}[];

  @Prop({ default: [] })
  readonly selectedCategories!: number[];

  markers: MarkerResult[] = [];

  events: Event[] = [];

  currentPage: number = 1;

  totalPages: number = 1;

  isLoading = false;

  mounted() {
    if (this.selectedCategories.length !== 1) {
      this.getEvents();
      this.getMarkers();
    }
  }

  async getMarkers() {
    try {
      const result: AxiosResponse<MarkerResult[]> = await Axios.get(this.markersUrl);
      result.data.forEach((marker) => {
        this.markers.push(marker);
      });
    }
    catch (error) {
      console.log(error);
    }
  }

  async getEvents() {
    try {
      const result: AxiosResponse<EventResult> = await Axios.get(this.listUrl);
      this.events = result.data.events;
      this.currentPage = result.data.page;
      this.totalPages = result.data.totalPages;
    }
    catch (error) {
      console.log(error);
    }
  }

  onPageClicked(number: number) {
    this.currentPage = number;
    this.$el.scrollIntoView();
  }

  onSearchResult(searchResult: any) {
    this.currentPage = searchResult.currentPage;
    this.totalPages = searchResult.totalPages;
    if (searchResult.markers) {
      this.markers = searchResult.markers.filter((marker: any) => {
        return marker.latitude && marker.longitude;
      });;
    }
    this.events = searchResult.events;
  }
}
